export default __webpack_public_path__ + "static/media/bkg--interiors-2.d9678078.jpg";